import { useRef } from "react";
import { Button } from "antd";
import moment from "moment";
import { PrinterOutlined } from "@ant-design/icons";
import "../../../src/styles/css/print.css";

export default function MailViewer({ body }) {
  const printRef = useRef();
  const handlePrint = () => {
    // const printWindow = window.open("", "_blank");
    const printWindow = window.print();

    // const content = `
    //   <html>
    //     <head>
    //       <title>Mail</title>
    //       <style>
    //         body {
    //           font-family: Arial, sans-serif;
    //           font-size: 16px;
    //           margin: 0;
    //           padding: 0;
    //         }
    //         .content {
    //           margin: 2em;
    //         }
    //         .header {
    //           background: #d8d8d8;
    //           padding: 0 12px;
    //         }
    //         .view-only-mail-body {
    //           background: #fff;
    //           padding: 1em;
    //           margin-top: 2em;
    //           height: auto;
    //           overflow: auto;
    //         }
    //       </style>
    //     </head>
    //     <body>
    //       <div class="content">
    //         <div class="header">
    //           <div><span>Subject: ${body?.mailSubject}</span></div>
    //           <div><span>From: ${body?.mailSenderAddress}</span></div>
    //           <div><span>To: ${body?.mailTo}</span></div>
    //           <div><span>CC: ${body?.mailCC}</span></div>
    //           <div><span>Reference: ${body?.mailReference}</span></div>
    //           <div><span>Date: ${
    //             body?.mailDate
    //               ? moment(body?.mailDate).format("YYYY-MM-DD h:mm:ss a")
    //               : ""
    //           }</span></div>
    //         </div>

    //         <div class="view-only-mail-body">
    //           ${body?.mailBody}
    //         </div>
    //       </div>
    //     </body>
    //   </html>
    // `;

    // printWindow.document.write(content);
    // printWindow.document.close();

    // window.frames.print();
    // window.frames.close();
  };

  return (
    <>
      <Button type="type" style={{ margin: "0.5em 2em" }} onClick={handlePrint}>
        Print
        <PrinterOutlined
          style={{
            // padding: "0 2em",
            fontSize: "18px",
            color: "#000000",
          }}
        />
      </Button>

      <main ref={printRef} id="printable-content">
        <section
          style={{
            margin: "0 2em",
            background: "#d8d8d8",
            padding: "0 12px",
          }}
        >
          <div>
            <span>Subject: {body?.mailSubject}</span>
          </div>
          <div>
            <span>From: {body?.mailSenderAddress}</span>
          </div>
          <div>
            <span>To: {body?.mailTo}</span>
          </div>
          <div>
            <span>CC: {body?.mailCC}</span>
          </div>
          <div>
            <span>Reference: {body?.mailReference}</span>
          </div>
          <div>
            <span>
              Date:{" "}
              {body?.mailDate
                ? moment(body?.mailDate).format("YYYY-MM-DD h:mm:ss a")
                : ""}
            </span>
          </div>
        </section>

        <div
          className="view-only-mail-body"
          style={{
            background: "#FFFFFF",
            padding: "1em",
            height: "600px",
            overflow: "auto",
            margin: "0 2em 2em 2em",
          }}
          dangerouslySetInnerHTML={{ __html: body?.mailBody }}
        />
      </main>
    </>
  );
}
